var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdhocRequestsFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.417 0.71582C12.133 0.71582 12.8198 1.0006 13.3262 1.50684L16.3213 4.50195C16.8276 5.0083 17.1123 5.69505 17.1123 6.41113V12.5352L16.8203 12.2432L16.6982 12.1338C16.0698 11.6213 15.1424 11.6574 14.5566 12.2432C13.9709 12.8289 13.9347 13.7563 14.4473 14.3848L14.5566 14.5068L14.6377 14.5879H11.751C11.5786 14.5879 11.4129 14.5194 11.291 14.3975C11.1691 14.2756 11.1006 14.1099 11.1006 13.9375V10C11.1006 9.11634 10.3846 8.40039 9.50098 8.40039C8.61732 8.40039 7.90137 9.11634 7.90137 10V13.9375C7.90137 14.9586 8.3063 15.9381 9.02832 16.6602C9.75034 17.3822 10.7299 17.7871 11.751 17.7871H14.6377L14.5566 17.8682C14.2998 18.125 14.1502 18.4479 14.1045 18.7822H4.0791C3.14033 18.7822 2.37908 18.0217 2.37891 17.083V3.08301C2.37891 2.45533 2.62843 1.85302 3.07227 1.40918C3.5161 0.965344 4.11841 0.71582 4.74609 0.71582H11.417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 13.375L18.5 16.1875L15.6875 19",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10V13.9375C9.5 14.5342 9.73705 15.1065 10.159 15.5285C10.581 15.9504 11.1533 16.1875 11.75 16.1875H18.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhocRequestsFilledV2);
export default __webpack_public_path__ + "static/media/adhocRequestsFilledV2.53138b1bb225ada418b0b10694c52b28.svg";
export { ForwardRef as ReactComponent };